module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Editar', {
    attrs: {
      "anexo": _vm.formData,
      "parent": this,
      "showForm": _vm.showFormEdit
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Inserir Anexo",
      "onRegister": (this.validarPermissao(576) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getLtcatAnexo,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.loadingTable,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-499e3752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/anexo/index.vue
// module id = 1471
// module chunks = 45